import React, { Component } from 'react';
import "./backButton.css";
import {HeaderHeight, MobileHeaderHeight,Colors} from "./../../utils/constants"
import {withRouter} from "react-router";

class BackButton extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }
  goBack = () =>{
    this.props.history.goBack();
  }

  render() {
    let headerHeight = HeaderHeight +20;
    if(window.outerWidth < 800){
      headerHeight = MobileHeaderHeight +20;
    }
    return (
      <div className="back-button" onClick={this.goBack}>
        <img className="back-button-icon" src="/images/back-white.png" />
      </div>
    );
  }
}

export default withRouter(BackButton)



// WEBPACK FOOTER //
// ./src/alpineComponents/backButton/index.js